import { RouteHttpVerb } from "@devowl-wp/utils";
export const locationRestStatsMainGet = {
    path: "/stats/main",
    method: RouteHttpVerb.GET
};
